import React from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import PropTypes from 'prop-types';

/** Count + optional export icon button under the control row. */
export function ResultMeta({
  countLabel,
  onExport = null,
  exportLabel = 'Export',
  exportDisabled = false,
}) {
  return (
    <div className="onyx-result-meta" data-testid="onyx-result-meta">
      <span className="onyx-result-meta__count">{countLabel}</span>
      {onExport ? (
        <button
          type="button"
          className="onyx-result-meta__export"
          onClick={onExport}
          disabled={exportDisabled}
          aria-label={exportLabel}
          title={exportLabel}
          data-testid="onyx-export-btn"
        >
          <DownloadIcon fontSize="inherit" />
        </button>
      ) : null}
    </div>
  );
}

ResultMeta.propTypes = {
  countLabel: PropTypes.string.isRequired,
  onExport: PropTypes.func,
  exportLabel: PropTypes.string,
  exportDisabled: PropTypes.bool,
};
